import {ready, createComponent} from '@/shared'
import {ManufacturerListConfig} from '@/config/manufacturerListConfig'
import {getManufacturerRatings} from '@/api/productReviews/getManufacturerRatings'
import Rating from '@/components/Rating'

function renderRatings (ratings) {
  const groupedRatings = ratings.reduce((prev, current) => {
    return {...prev, [current.id]: current.rating}
  }, {})

  Array.from(document.querySelectorAll('[data-component="manufacturer-rating"]'))
    .forEach((element) => {
      const rating = groupedRatings[element.getAttribute('data-manufacturer-id')] || 0
      createComponent(element, Rating, {rating: rating})
    })
}

ready(function () {
  getManufacturerRatings(ManufacturerListConfig.manufacturerIds)
    .then(ratings => {
      renderRatings(ratings)
    })
})



// WEBPACK FOOTER //
// ./src/manufacturer-list.js